/* RESPONSIBLE TEAM: team-inbox-management */
import { inject as service } from '@ember/service';
import { ParentAction } from './action';
import type InboxHotkeys from 'embercom/services/inbox-hotkeys';
import { HotkeyID } from 'embercom/services/inbox-hotkeys/HotkeyID';
import type Snackbar from 'embercom/services/snackbar';
import type TwilioService from 'embercom/services/twilio-service';
export default class ConvertToCustomerTicket extends ParentAction {
  @service declare inboxHotkeys: InboxHotkeys;
  @service declare twilioService: TwilioService;
  @service declare snackbar: Snackbar;

  constructor(args: any) {
    super(args);
    this.shortcuts = this.inboxHotkeys.hotkeysMap[HotkeyID.ConvertToTicket];
  }

  id = 'convert-to-customer-ticket';
  icon = 'ticket' as const;
  paneComponent = 'inbox2/command-k/convert-to-ticket/pane';

  canActivate(): boolean {
    if (this.twilioService.isActiveCall) {
      this.snackbar.notify(this.intl.t('inbox.command-k.convert-to-ticket-disabled-during-call'));
      return false;
    }
    return true;
  }
}
